import React from 'react'
import classNames from 'classnames'
import * as style from './styles.scss'
import Section from './Section'

export default
function FlexSection(props) {
  return (<Section
    {...props}
    className={classNames(style.navbarFlexSection, props.className)}
  />)
}
